module.exports = {"id":"234774","name":"Konstantinos Laifis","rating":"73","photo":"./data/images/photos/1/234774.png","club":{"name":"Standard Liège","logo":"./data/images/clubs/StandardLiege.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KonstantinosLaifis0.json
// module id = 2399
// module chunks = 0